var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-item"},[(_vm.isNameDisplayed)?_c('div',{staticClass:"label",class:{ disabled: _vm.disabled }},[_vm._v(" "+_vm._s(_vm.name)+" ")]):_vm._e(),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }